import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useAppState } from '../../contexts/AppStateContext';
import { Member } from '../../types/family';
import { Logo } from './Logo';
export function WhoAreYou() {
  const {
    family,
    pickViewer
  } = useAppState();
  const reduce = useReducedMotion();
  const active = family.members.filter(m => !m.archived);
  const kids = active.filter(m => m.role === 'otrok');
  const parents = active.filter(m => m.role === 'skrbnik');
  return <main className="flex min-h-screen w-full flex-col items-center bg-canvas px-4 py-10 font-sans text-ink md:justify-center md:py-16" data-id="element-946" data-mp="3is5mmhkvjl6t">
      <Logo data-id="element-947" data-mp="3dzumpeq4vze9" />
      <motion.div initial={reduce ? false : {
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="mt-8 w-full max-w-3xl text-center" data-id="element-948" data-mp="3dzmazq5qz04n">
        <p className="text-sm font-bold text-muted" data-id="element-949" data-mp="5llz6l2gxysy">Družina {family.name}</p>
        <h1 className="mt-1 font-display text-4xl md:text-5xl" data-id="element-950" data-mp="2p6houn3n7gql">Kdo si?</h1>

        <ul className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5" data-id="element-951" data-mp="2p8lx1h8kr1wo">
          {kids.map(m => <PersonButton key={m.id} member={m} onPick={pickViewer} data-id="element-952" data-mp="2fgpotdcrxveq" />)}
        </ul>

        {parents.length > 0 && <>
            <p className="mt-8 text-xs font-extrabold text-muted" data-id="element-953" data-mp="2ker9g2pum2sb">Starša</p>
            <ul className="mx-auto mt-3 grid max-w-md grid-cols-2 gap-3" data-id="element-954" data-mp="25i0fi8yy1ja3">
              {parents.map(m => <PersonButton key={m.id} member={m} onPick={pickViewer} parent data-id="element-955" data-mp="2ahv4u832m0t1" />)}
            </ul>
          </>}

        <p className="mt-10 text-xs text-muted" data-id="element-956" data-mp="1wjof5f89z74g">Vzorčni prototip – brez gesel. Osebo lahko kadarkoli zamenjaš v meniju pod svojim avatarjem.</p>
      </motion.div>
    </main>;
}
function PersonButton({
  member,
  onPick,
  parent
}: {
  member: Member;
  onPick: (id: string) => void;
  parent?: boolean;
}) {
  return <li data-id="element-957" data-mp="3vsv8hnbamh48">
      <button type="button" onClick={() => onPick(member.id)} className="flex w-full flex-col items-center gap-3 rounded-3xl border-[1.5px] border-line bg-surface px-3 py-5 shadow-pressSoft transition-[transform,background-color] duration-150 ease-out hover:bg-[#FFFCF6] active:translate-y-[2px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" data-id="element-958" data-mp="3vslgju6otzvw">
        <span className="grid h-16 w-16 place-items-center rounded-full font-display text-2xl text-white md:h-20 md:w-20 md:text-3xl" style={{
        backgroundColor: member.color
      }} aria-hidden="true" data-id="element-959" data-mp="gyw8to3x4gg1">
          {member.name.charAt(0)}
        </span>
        <span className="text-base font-extrabold" data-id="element-960" data-mp="7701rnjutfzo">{member.name}</span>
        {parent && <span className="-mt-2 text-xs font-bold text-muted" data-id="element-961" data-mp="29q1tdyu9lxl">starš</span>}
      </button>
    </li>;
}